(function() {

  var KLAVIYO_COMPANY_ID = 'Rf2iei';
  var KLAVIYO_FORM_ID = 'XAXxZX';

  function loadKlaviyo() {
    if (window._klOnsite) return;
    var script = document.createElement('script');
    script.async = true;
    script.type = 'text/javascript';
    script.src = 'https://static.klaviyo.com/onsite/js/klaviyo.js?company_id=' + KLAVIYO_COMPANY_ID;
    document.head.appendChild(script);
  }

  function createWaitlistButton() {
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'waitlist-btn';
    btn.innerHTML = '&#9993; JOIN THE WAITLIST - 15% OFF';
    btn.style.cssText = 'display:block; width:100%; padding:18px 24px; background:#D3AD03; color:#545454; border:none; font-size:16px; font-weight:600; letter-spacing:1px; text-transform:uppercase; cursor:pointer; margin-top:8px; min-height:54px; transition:background 0.3s, color 0.3s;';

    btn.addEventListener('mouseenter', function() {
      btn.style.background = '#545454';
      btn.style.color = '#C8A96E';
    });
    btn.addEventListener('mouseleave', function() {
      btn.style.background = '#D3AD03';
      btn.style.color = '#545454';
    });
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      if (window._klOnsite) {
        window._klOnsite.push(['openForm', KLAVIYO_FORM_ID]);
      }
    });
    return btn;
  }

  function hideAndReplace() {
    var selectors = [
      '[name="add"]',
      '.product-form__cart-submit',
      '.btn--add-to-cart',
      '.add-to-cart',
      '#AddToCart',
      '.shopify-payment-button',
      '.shopify-payment-button__button',
      'button[name="add"]'
    ];

    selectors.forEach(function(sel) {
      document.querySelectorAll(sel).forEach(function(el) {
        if (!el.dataset.waitlistReplaced) {
          el.style.display = 'none';
          el.dataset.waitlistReplaced = 'true';
          if (!el.parentNode.querySelector('.waitlist-btn')) {
            el.parentNode.insertBefore(createWaitlistButton(), el.nextSibling);
          }
        }
      });
    });
  }

  loadKlaviyo();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', hideAndReplace);
  } else {
    hideAndReplace();
  }

  var observer = new MutationObserver(function() { hideAndReplace(); });
  observer.observe(document.body, { childList: true, subtree: true });

})();